import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box } from '@rsos/components/capstone/base';
import {
  fetchAppCIDRs,
  updateAppCIDR,
  selectManagementByApp,
  selectUserOrgByApp,
} from '@rsos/sinatra';
import { notifyError } from '@rsos/utils/toastUtils';
import APP_NAME from '../../constants/appName';
import { isAnyCidrEnabled } from '../../utils/cidrHelpers';
import AccessRestrictionToggle from './AccessRestrictionToggle/';
import IPAddAddressForm from './IPAddAddressForm';
import IPAddressManagement from './IPAddressManagement';
import { Title, Description } from './IPSecurityManagement.styles';
import UpdateCidrModal from './modals/UpdateCidrModal';

const IPSecurityManagement = () => {
  const dispatch = useDispatch();
  const sinatra = useSelector(state => state.sinatra);
  const org = selectUserOrgByApp(sinatra, APP_NAME);
  const management = selectManagementByApp(sinatra, org.id, APP_NAME);
  const cidrRecords = management.whitelistedIPs.records;
  const featureEnabled = isAnyCidrEnabled(cidrRecords);
  const { loading } = management.whitelistedIPs;

  const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);

  useEffect(() => {
    dispatch(fetchAppCIDRs(org.id, APP_NAME)).catch(action => {
      const { error } = action;
      notifyError(error.response.data.detail);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUpdateRequest = () => {
    setIsUpdateModalVisible(prev => !prev);
  };
  const handlePatchAll = async () => {
    await cidrRecords.map(cidr => {
      if (cidr.enabled === featureEnabled) {
        cidr.enabled = !featureEnabled;
        return dispatch(updateAppCIDR(org.id, APP_NAME, cidr)).catch(action => {
          const { error } = action;
          notifyError(error.response.data.detail);
        });
      }
    });
    if (featureEnabled) {
      setIsUpdateModalVisible(prev => !prev);
    }
  };

  return (
    <>
      <Title>Security</Title>
      <Box horizontal justify="space-between" align="center" mb={20}>
        <Description>Manage IP Address</Description>
        <AccessRestrictionToggle
          onClick={featureEnabled ? handleUpdateRequest : handlePatchAll}
          isOn={featureEnabled}
          disabled={loading || cidrRecords.length === 0}
        />
      </Box>
      <IPAddAddressForm />
      <IPAddressManagement cidrRecords={cidrRecords} />
      <UpdateCidrModal
        isOpened={isUpdateModalVisible}
        onClose={() => {
          setIsUpdateModalVisible(prev => !prev);
        }}
        handleUpdate={handlePatchAll}
      />
    </>
  );
};

export default IPSecurityManagement;
